<nz-steps class="hide-sm" nzDirection="vertical" nzSize="small" [nzCurrent]="currentIndex"
  (nzIndexChange)="onIndexChange($event)">
  <nz-step *ngFor="let step of stepOptions" [nzTitle]="step.label" [nzStatus]="step.status || stepStatus.WAIT"
    [nzDisabled]="!!step.isDisabled"></nz-step>
</nz-steps>

<div class="hide show-sm">
  <div class="x-between">
    <h5 *ngIf="shouldShowTitle" class="pt-4 mb-4 grey-50" nz-typography i18n>Today's Session</h5>
    <nz-progress [nzPercent]="progressInPercentage" [nzShowInfo]="false" nzStatus="normal"></nz-progress>
  </div>
  <div class="x-between">
    <h3 class="mb-0-imp" nz-typography>{{stepOptions[currentIndex]?.label}}</h3>
    <div>
      <h3> {{currentIndex + 1}}
        <span class="no-bold grey-50 float-right">/{{stepOptions?.length}}</span>
      </h3>
    </div>
  </div>
</div>